import { render, staticRenderFns } from "./PortalNotificationSkeltonLoader.vue?vue&type=template&id=255eab6a&scoped=true&"
import script from "./PortalNotificationSkeltonLoader.vue?vue&type=script&lang=ts&"
export * from "./PortalNotificationSkeltonLoader.vue?vue&type=script&lang=ts&"
import style0 from "./PortalNotificationSkeltonLoader.vue?vue&type=style&index=0&id=255eab6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255eab6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VItemGroup,VRow,VSkeletonLoader})
